import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { GetCompanySetting, getStoreInformation } from '../../services/companyService';
import { Eye } from '@phosphor-icons/react';

const StoreHeaderImage = ({ storeId, store }) => {
    const [topImage, setTopImage] = useState('assets/images/profile_temp/bgheadermirrored.jpg');

    const [logoImage, setLogoImage] = useState('assets/images/profile_temp/profile1.png');

    const [config, setConfig] = useState(null);

    const [shopName, setShopName] = useState('');

    const [shopLink, setShopLink] = useState('');

    const [briefDescription, setBriefDescription] = useState('');

    const [pageCompanyConfig, setPageCompanyConfig] = useState(null);

    // useEffect(() => {
    //     try {
    //         const config = JSON.parse(
    //             localStorage.getItem("pageCompany_app_config")
    //         );
    //         setPageCompanyConfig(config);
    //         console.log("config value", config)
    //         if (config?.topBanner) {
    //             setTopImage(config.topBanner);
    //         }

    //         if (config?.logo) {
    //             setLogoImage(config.logo);
    //         }
    //     } catch (e) {
    //         console.error("Invalid pageCompany_app_config", e);
    //     }
    // }, []);

    useEffect(() => {
        // console.log("storeId header", storeId.storeId)
        // if (!storeId.storeId) return;
        if (!store) return;

        const load = async () => {
            try {
                // const data = await getStoreInformation(storeId.storeId);
                // console.log("store header data", data)
                setConfig(store);
                // console.log("store header data", store)
                if (store?.topBanner) {
                    setTopImage(store.topBanner);
                }
                if (store?.logo) {
                    setLogoImage(store.logo);
                }
                if (store?.businessName) {
                    setShopName(store?.businessName);
                }

                setShopLink(store?.link ?? '');
            } catch (e) {
                console.error('Failed to load store info', e);
            }
        };

        load();
    }, [store]);

    return (
        <section className="storeSellerHeader">
            <div className="container">
                <div className="profil_imagebg" style={{ backgroundImage: `url(${topImage}?width=1440)` }}>
                    <div className="profile_data p-20">
                        <div className="d-flex align-items-center gap-10">
                            <div className="profile_image">
                                <img src={logoImage+"?width=122"} alt="" className="image_profile h-100 w-auto" />
                            </div>
                            <div className="profile_info">
                                <div className="profile_name" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    <span>{shopName}</span>
                                    <img src="assets/images/icon/verified.png" width={28} height={28} />
                                </div>
                                <div className="profile_description mb-5">{briefDescription}</div>
                                <div className="profile_store_link">
                                    <i className="ph-bold ph-link-simple"></i> {shopLink}
                                </div>
                                <span className="text-white fw-normal d-flex flex-align gap-4">
                                    <Eye size={16} /> {store?.viewCount}
                                </span>{' '}
                            </div>
                        </div>
                        <div className="d-none justify-content-end mt-10">
                            <button className="btn_custom outline_white">
                                <i className="ph ph-plus"></i> Follow
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default StoreHeaderImage;
